<template>
    <dash
        icon="fa fa-book"
        titulo="PROJETOS SGTEC"
        subTitulo="APOIO"
        @click.native="$router.push({ name: 'Sgtec_Apoios_Projetos' })"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
